import { motion } from "framer-motion";

export default function PageHeader({ overline, title, subtitle, testid }) {
    return (
        <section data-testid={testid} className="bg-navy-deep text-white relative overflow-hidden">
            <div className="absolute inset-0 court-lines opacity-30" />
            <div className="absolute inset-0 noise" />
            <div className="relative max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, ease: "easeOut" }}
                >
                    {overline && <div className="overline text-clay mb-3">{overline}</div>}
                    <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-none">{title}</h1>
                    {subtitle && <p className="mt-4 text-slate-300 max-w-2xl leading-relaxed">{subtitle}</p>}
                </motion.div>
            </div>
        </section>
    );
}
